import { JE_FCValidationNode, JE_JsonValidationContext } from "../interfaces";
import { JE_FQClaimXformSpec } from "../jsonFQContext";
import { addNodeErrorReport, claimHasDataType, validateClaimPresence } from "../jsonValidation/utils";
import { lookupInputClaim } from "./utils";

export interface JsonClaimTransformStringFormatData {
    inputClaim0: string;
    inputClaim1: string;
    formatString: string;
}

export const getClaimsForStringFormat = (transformData: any) => {
    let claims: string[] = [];
    if (transformData?.inputClaim0) {
        claims.push(transformData.inputClaim0);
    }
    if (transformData?.inputClaim1) {
        claims.push(transformData.inputClaim1);
    }
    return claims;
}

export const makeTransformForStringFormat: (nodeName: string, transformData: any, outputClaimId: string, inputClaimMap?: {[baseId: string]: string}) => JE_FQClaimXformSpec = (nodeName: string, transformData: any, outputClaimId: string, inputClaimMap?: {[baseId: string]: string}) => {
    let tData = transformData as JsonClaimTransformStringFormatData;
    return {
        id: `${nodeName}_stringFormat`,
        method: tData.inputClaim1 ? 'FormatStringMultipleClaims' : 'FormatStringClaim',
        inputClaims: tData.inputClaim1 ? [
            { claimId: lookupInputClaim(tData.inputClaim0, inputClaimMap), xformClaimType: 'inputClaim1' },
            { claimId: lookupInputClaim(tData.inputClaim1, inputClaimMap), xformClaimType: 'inputClaim2' }
        ] : [
            { claimId: lookupInputClaim(tData.inputClaim0, inputClaimMap), xformClaimType: 'inputClaim' }
        ],
        inputParameters: [
            { id: 'stringFormat', dataType: 'string', value: tData.formatString }
        ],
        outputClaims: [
            { claimId: outputClaimId, xformClaimType: 'outputClaim' }
        ]
    }
}

export const validateJsonForStringFormat = (vCtx: JE_JsonValidationContext, vNode: JE_FCValidationNode, transformData: any) => {
    if (!transformData) {
        addNodeErrorReport(vNode.nodeId, vCtx, "No transform data for stringFormat function");
    } else {
        if (!transformData.inputClaim0) {
            if (!transformData.inputClaim1) {
                addNodeErrorReport(vNode.nodeId, vCtx, "No input claims defined for stringFormat function");
            } else {
                addNodeErrorReport(vNode.nodeId, vCtx, "Second input claim defined without first input claim for stringFormat function");
            }
        }
        if (!transformData.formatString) {
            addNodeErrorReport(vNode.nodeId, vCtx, "No format string defined for stringFormat function");
        } else if (!transformData.formatString.includes("{0}")) {
            addNodeErrorReport(vNode.nodeId, vCtx, "No placeholder for first input claim ('{0}') present in format string for stringFormat function");
        } else if (transformData.inputClaim1 && !transformData.formatString.includes("{1}")) {
            addNodeErrorReport(vNode.nodeId, vCtx, "Second input claim defined for stringFormat function but matching placeholder ('{1}') is not present in format string");
        }
        if (transformData.inputClaim0) {
            validateClaimPresence(vCtx, vNode, transformData.inputClaim0, '', 'declared as first input to stringFormat function', true);
            if (!claimHasDataType(vCtx, transformData.inputClaim0, 'string')) {
                addNodeErrorReport(vNode.nodeId, vCtx, `First input claim '${transformData.inputClaim0}' to stringFormat function is of non-string type`);
            }
        }
        if (transformData.inputClaim1) {
            validateClaimPresence(vCtx, vNode, transformData.inputClaim1, '', 'declared as second input to stringFormat function', true);
            if (!claimHasDataType(vCtx, transformData.inputClaim1, 'string')) {
                addNodeErrorReport(vNode.nodeId, vCtx, `First input claim '${transformData.inputClaim1}' to stringFormat function is of non-string type`);
            }
        }
    }
}

